import React, { useState, useEffect } from "react";
import { baseurl } from "../utility/helper";

export default function PriorTestAccept() {
  const [tests, setTests] = useState([]);
  const [notes, setNotes] = useState([]);

  const [name, setName] = useState("");
  const [note, setNote] = useState("");

  const [editTestId, setEditTestId] = useState(null);
  const [editNoteId, setEditNoteId] = useState(null);
  const token = sessionStorage.getItem("token");
      
  const fetchData = async () => {
    if (!token) {
        console.error("No authorization token found.");
        return;
      }
    const res = await fetch(`${baseurl}/admin/priortestaccept`, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
    const data = await res.json();
    setTests(data.tests);
    setNotes(data.notes);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const addOrUpdateTest = async () => {
    if (!name) return alert("Enter test name");

    const url = editTestId
      ? `${baseurl}/admin/priortestaccept/${editTestId}`
      : `${baseurl}/admin/priortestaccept`;

    await fetch(url, {
      method: editTestId ? "PUT" : "POST",
      headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        },
      body: JSON.stringify({ name }),
    });

    setName("");
    setEditTestId(null);
    fetchData();
  };

  const addOrUpdateNote = async () => {
    if (!note) return alert("Enter note");

    const url = editNoteId
      ? `${baseurl}/admin/priornotes/${editNoteId}`
      : `${baseurl}/admin/priornotes`;

    await fetch(url, {
      method: editNoteId ? "PUT" : "POST",
      headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        },
      body: JSON.stringify({ note }),
    });

    setNote("");
    setEditNoteId(null);
    fetchData();
  };

  const deleteTest = async (id) => {
    if (!window.confirm("Delete this test?")) return;
    await fetch(`${baseurl}/admin/priortestaccept/${id}`, { method: "DELETE",headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        } });
    fetchData();
  };

  const deleteNote = async (id) => {
    if (!window.confirm("Delete this note?")) return;
    await fetch(`${baseurl}/admin/priornotes/${id}`, { method: "DELETE", headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        } });
    fetchData();
  };

  const resetForm = () => {
    setName("");
    setNote("");
    setEditTestId(null);
    setEditNoteId(null);
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <h4>Prior Evidence Test</h4>
          <div className="card p-3 mb-3">
            <input
              className="form-control mb-2"
              placeholder="Test Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <button className="btn btn-primary" onClick={addOrUpdateTest}>
              {editTestId ? "Update Test" : "Save Test"}
            </button>
            &nbsp;
            <button className="btn btn-secondary" onClick={resetForm}>
              Reset
            </button>
          </div>
        </div>
        <div className="col-md-6">
          <h4>Prior Evidence Note</h4>
          <div className="card p-3 mb-3">
            <textarea
              className="form-control mb-2"
              placeholder="Enter note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
            <button className="btn btn-success" onClick={addOrUpdateNote}>
              {editNoteId ? "Update Note" : "Save Note"}
            </button>
            &nbsp;
            <button className="btn btn-secondary" onClick={resetForm}>
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="card p-3 mb-3">
          <h5>Tests List</h5>
          <br />
          <ul className="list-group mb-4">
            {tests.map((t) => (
              <li
                key={t.id}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>{t.name}</span>
                <div>
                  <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => {
                      setName(t.name);
                      setEditTestId(t.id);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteTest(t.id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card p-3 mb-3">
          <h5>Notes List</h5>
          <br />
          <ul className="list-group mb-4">
            {notes.map((n) => (
              <li
                key={n.id}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>{n.note}</span>
                <div>
                  <button
                    className="btn btn-sm btn-outline-success me-2"
                    onClick={() => {
                      setNote(n.note);
                      setEditNoteId(n.id);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteNote(n.id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
}
